import {StyleSheet} from 'react-native';

import {denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    // paddingBottom: 20,
  },
  headerText: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1A1A1A',
    lineHeight: 24,
  },

  descriptionText: {
    fontSize: 13,
    color: '#344054',
    marginBottom: 16,
    lineHeight: 22,
  },

  checkRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
  },

  checkRowLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    flexShrink: 1,
    paddingRight: 8,
  },

  radioLabel: {
    fontSize: 16,
    color: '#1A1A1A',
    marginLeft: 12,
    lineHeight: 22,
    flexShrink: 1,
  },

  requiredTextContainer: {
    marginLeft: 8,
    flexShrink: 0,
    alignItems: 'flex-end',
  },

  requiredTextContainerLandscape: {
    paddingRight: 50,
  },
  requiredText: {
    fontSize: 14,
    color: '#344054',
    lineHeight: 20,
    textAlign: 'right',
  },

  selectedIcon: {
    fontSize: 22,
    // color: '#2F5BFF',
    color: denim,
  },

  unSelectedIcon: {
    fontSize: 17,
    borderColor: '#98A2B3',
    borderStyle: 'solid',
    borderWidth: 2,
    borderRadius: 4,
    color: 'transparent',
    width: 20,
    height: 20,
  },

  radioLabelDisabled: {
    color: '#98A2B3',
  },

  requiredTextDisabled: {
    color: '#98A2B3',
  },

  selectedIconDisabled: {
    color: '#84A9FF',
  },

  unSelectedIconDisabled: {
    borderColor: '#D0D5DD',
  },
  containerOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 10,
  },

  loaderContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 11,
  },
});
